// Utilitários de CNPJ da empresa (frontend).
// A empresa armazena apenas os 14 dígitos; a máscara é só para exibição.

export const CNPJ_MASK = "99.999.999/9999-99";

export const onlyDigits = (value) => (value || "").replace(/\D/g, "");

// Exibe o CNPJ com máscara a partir dos dígitos armazenados.
export const formatCnpj = (value) => {
  const cnpj = onlyDigits(value);
  if (cnpj.length !== 14) return value || "";
  return cnpj.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
    "$1.$2.$3/$4-$5"
  );
};

export const isValidCnpj = (value) => {
  const cnpj = onlyDigits(value);

  if (cnpj.length !== 14) return false;

  // Rejeita todos os dígitos iguais (ex.: 11111111111111)
  if (/^(\d)\1{13}$/.test(cnpj)) return false;

  const calcDigit = (base) => {
    const weights =
      base.length === 12
        ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
        : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    const sum = base
      .split("")
      .reduce((acc, digit, index) => acc + Number(digit) * weights[index], 0);

    const rest = sum % 11;
    return rest < 2 ? 0 : 11 - rest;
  };

  const firstDigit = calcDigit(cnpj.slice(0, 12));
  if (firstDigit !== Number(cnpj[12])) return false;

  const secondDigit = calcDigit(cnpj.slice(0, 13));
  if (secondDigit !== Number(cnpj[13])) return false;

  return true;
};
